import { Component } from 'react';
import { captureException } from '@sentry/react';
import { Link as MuiLink, Typography, Button as MuiButton } from '@mui/material';
import { Alert } from '@client/components/globals/Modal';

export class LoaderErrorBoundary extends Component<any, { error: Error }> {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidCatch(e) {
    this.setState({
      error: e,
    });

    if (process.env.NODE_ENV !== 'development') {
      captureException(e);
    } else {
      console.warn(e);
    }

    Alert.show({
      title: 'Something didn\'t load correctly...',
      maxWidth: 'sm',
      body: (
        <>
          <Typography
            variant="body1"
            gutterBottom
          >
            This page tried to load but failed due to a connection issue.
            You may have briefly lost your internet connection. Please refresh
            the page and try again.
          </Typography>

          <Typography
            variant="body1"
            gutterBottom
          >
            Contact us at
            {' '}

            <MuiLink
              id="sda-error-email-link"
              href={`mailto:${process.env.SUPPORT_EMAIL}`}
              variant="body1"
              color="primary"
            >
              {process.env.SUPPORT_EMAIL}
            </MuiLink>

            {' '}
            if the issue persists.
          </Typography>
        </>
      ),
      buttons: [(
        <MuiButton
          id="sda-modal-ok-button"
          type="button"
          key="button-ok"
          aria-label="close"
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
        >
          Refresh
        </MuiButton>
      )] as any,
    });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return <div />;
    }

    return children;
  }
}
